<template>
  <div class="shinsotsu">
    <router-view
      v-bind:form_data="form_data"
      v-bind:click="click"
      v-on:click_kakunin="click=true"
      v-on:removeData="remove_data"
      v-on:getId="area=$event"
    ></router-view>
  </div>
</template>
<script>
const data = {
  job: "",
  kinmuchi: [],
  name: { kanji: "", furigana: "" },
  seibetsu: "",
  graduate: { year: "", month: "" },
  university: "",
  juusyo: { yuubin_num: "", address: "" },
  tel: "",
  mail: "",
  question: "",
  area:"",
};
export default {
  metaInfo: {
    titleTemplate: "%s ファミリー庭園"
  },
  data() {
    return {
      form_data: JSON.parse(JSON.stringify(data)),
      click: false,
      area:""
    };
  },
  methods: {
    remove_data() {
      localStorage.removeItem("savedata");
      this.form_data = JSON.parse(JSON.stringify(data));
      this.click = false;
    }
  },
  mounted() {
    var a = JSON.parse(localStorage.getItem("savedata"));
    if (a) {
      this.form_data = a;
    }
    if (this.area) {
      this.form_data.area = this.area;
    }
  },
  watch: {
    form_data: {
      handler() {
        localStorage.setItem("savedata", JSON.stringify(this.form_data));
      },
      deep: true
    }
  }
};
</script>

